import React from 'react';

const PineTreeIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path d='M14 25v-3H7l5-5H9l5-5h-3l5-5 5 5h-3l5 5h-3l5 5h-7v3z' fill='currentColor' fillRule='nonzero' />
  </svg>
);

export default PineTreeIcon;
